module.exports = __webpack_public_path__ + "fonts/unicons.b5ae965.woff2";